// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__nndOr","title":"Images45_title__2_Co7","images":"Images45_images__2Doia"};